import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { DialogOverlay } from './DialogOverlay.js';
import { DialogContent } from './DialogContent.js';
import { DialogCard } from './DialogCard.js';
import { DialogLayout } from './DialogLayout.js';

var Dialog = forwardRef(function Dialog(_a, ref) {
    var children = _a.children, contentRef = _a.contentRef, layoutRef = _a.layoutRef, _b = _a.scrollableBody, scrollableBody = _b === void 0 ? true : _b, _c = _a.size, size = _c === void 0 ? "md" : _c, _d = _a.allowPinchZoom, allowPinchZoom = _d === void 0 ? false : _d, initialFocusRef = _a.initialFocusRef, isOpen = _a.isOpen, onDismiss = _a.onDismiss, overlaySx = _a.overlaySx, _e = _a.overlay, overlay = _e === void 0 ? {
        allowPinchZoom: allowPinchZoom,
        initialFocusRef: initialFocusRef,
        isOpen: isOpen,
        onDismiss: onDismiss,
        sx: overlaySx,
    } : _e, props = __rest(_a, ["children", "contentRef", "layoutRef", "scrollableBody", "size", "allowPinchZoom", "initialFocusRef", "isOpen", "onDismiss", "overlaySx", "overlay"]);
    return (jsx(DialogOverlay, __assign({ ref: ref }, overlay, { children: jsx(DialogContent, __assign({ ref: contentRef, size: size }, props, { children: jsx(DialogCard, { children: jsx(DialogLayout, __assign({ ref: layoutRef, scrollableBody: scrollableBody }, { children: children })) }) })) })));
});

export { Dialog };
//# sourceMappingURL=Dialog.js.map
